var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dialog',{attrs:{"titleText":"Error"},on:{"close":function($event){return _vm.close()}}},[_c('div',{staticClass:"error-dialog-content"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }